import React, { useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';

import useApi from 'common/useApi';

import LoginCard from 'components/LoginCard';
import InputEmail from 'components/InputEmail';
import useFormApiErrors from 'common/useFormApiErrors';
import { useNavigate, useParams } from 'react-router-dom';
import InputPassword from 'components/InputPassword';

const PasswordReset = () => {

  const { token } = useParams();
  const endpoint = token ? '/api/forgot-password/confirm' : '/api/forgot-password';
  const { isLoading, isError, error, isSuccess, mutate } = useApi('post', endpoint);
  const formMethods = useForm({ mode: 'onChange' });
  const { handleSubmit, formState: { isSubmitting, isDirty, isValid }, setError } = formMethods;
  const navigate = useNavigate();

  const onSubmit = ({ email, password, password_confirm }: Record<string, string>) => {
    if(token) {
      mutate({
        password,
        password_confirm,
        token,
      });
    } else {
      mutate({ email });
    }
  };

  // Navigate only after the reset actually succeeds — navigating right after
  // mutate() bounced the user to login even on failure (expired token, policy
  // rejection), swallowing the error feedback.
  useEffect(() => {
    if (isSuccess && token) {
      navigate('/login');
    }
  }, [isSuccess]);

  useFormApiErrors(
    isError,
    error,
    setError,
    isSuccess,
    token
      ? 'Your password has been successfully reset'
      : 'If the email address exists, instructions to reset your password have been sent to you',
  );

  return (
    <LoginCard title='Reset your password' create={false}>
      <FormProvider {...formMethods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          {token ? (
            <>
              <InputPassword
                name='password'
                title='New Password'
                placeholder='New Password'
                disabled={isLoading}
              />
              <InputPassword
                name='password_confirm'
                placeholder='Confirm New Password'
                title='Confirm New Password'
                match='password'
                disabled={isLoading}
              />
            </>
          ) : (
            <InputEmail name='Email Address' field='email' />
          )}
          <button
            className='primary big'
            disabled={isLoading || isSubmitting || (!isValid && isDirty)}
          >
            Reset Password
          </button>
          <hr />
        </form>
      </FormProvider>
    </LoginCard>
  );
};

export default PasswordReset;